import React from 'react';

interface LogoProps {
    className?: string;
    showText?: boolean;
    lightMode?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ className = "w-10 h-10", showText = true, lightMode = false }) => (
  <div className="flex items-center gap-3.5 select-none group">
    <div className={`relative ${className} flex-shrink-0`}>
        {/* Abstract Gem Shape */}
        <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full drop-shadow-xl transform transition-transform duration-700 group-hover:rotate-[60deg]">
            <defs>
                <linearGradient id="gemGradient" x1="0" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
                    <stop offset="0%" stopColor="#6366f1" /> {/* Indigo 500 */}
                    <stop offset="50%" stopColor="#8b5cf6" /> {/* Violet 500 */}
                    <stop offset="100%" stopColor="#ec4899" /> {/* Pink 500 */}
                </linearGradient>
            </defs>
            
            {/* Main Hexagon Body */}
            <path d="M50 5 L93.3 28 V72 L50 95 L6.7 72 V28 Z" fill="url(#gemGradient)" stroke="white" strokeWidth="0.5" strokeOpacity="0.3" />
            
            {/* Internal Facets - Top Right Light */}
            <path d="M50 50 L50 5 L93.3 28 Z" fill="white" fillOpacity="0.3" />
            {/* Internal Facets - Right Mid Shadow */}
            <path d="M50 50 L93.3 28 V72 Z" fill="black" fillOpacity="0.1" />
            {/* Internal Facets - Bottom Right Dark */}
            <path d="M50 50 L50 95 L93.3 72 Z" fill="black" fillOpacity="0.25" />
            {/* Internal Facets - Bottom Left Shadow */}
            <path d="M50 50 L6.7 72 L50 95 Z" fill="black" fillOpacity="0.1" />
            {/* Internal Facets - Left Mid Light */}
            <path d="M50 50 L6.7 28 L6.7 72 Z" fill="white" fillOpacity="0.05" />
            {/* Internal Facets - Top Left Light */}
            <path d="M50 50 L50 5 L6.7 28 Z" fill="white" fillOpacity="0.2" />
            
            {/* Center Highlight */}
            <circle cx="50" cy="50" r="3" fill="white" className="animate-pulse" />
        </svg>
        
        {/* Ambient Glow */}
        <div className="absolute inset-0 bg-indigo-500/40 blur-2xl rounded-full -z-10 scale-75 group-hover:scale-110 transition-transform duration-700 opacity-60"></div>
    </div>
    
    {showText && (
        <div className="flex flex-col justify-center">
            <span className={`text-lg font-extrabold tracking-tight leading-none ${lightMode ? 'text-white' : 'text-slate-900'} font-sans`}>
              Ruby Oncology Insights
            </span>
        </div>
    )}
  </div>
);
